/* eslint-disable new-cap */
import {useState} from 'react';
import '@qep/shared/src/styles/_global.scss';
import {HEALTH_ENDPOINTS} from '@qep/types/src/index';
import {HasiStatus} from '@qep/common';
import {useConnectivity} from '@qep/shared/src/utils/connectivity';
import {
  getAuthClientId,
  getAuthRedirect,
  getAuthState,
  getFileServer,
} from '@qep/shared/src/utils/runtime-config';
import darkLogo from '@qep/shared/src/assets/img/darkLogo.svg';
import './Login.scss';

export const Login = () => {
  const [loading, setLoading] = useState(false);
  const connectivity = useConnectivity([HEALTH_ENDPOINTS.HTTP_CLIENT]);
  const httpConnectivity = connectivity[HEALTH_ENDPOINTS.HTTP_CLIENT];
  const isOpen = httpConnectivity
    && typeof httpConnectivity === 'object'
    && 'statusInfo' in httpConnectivity
    && httpConnectivity.statusInfo === HasiStatus.HASISTATUS_OK;
  const authUrl = `https://login.microsoftonline.com/57368c21-b8cf-42cf-bd0b-43ecd4bc62ae/oauth2/v2.0/authorize?client_id=${getAuthClientId()}
    &redirect_uri=${getAuthRedirect()}
    &scope=https://graph.microsoft.com/.default
    &state=${`{ "env": "${getAuthState()}", "timezone": "${Intl.DateTimeFormat().resolvedOptions().timeZone}","frontend": "${getFileServer()}","mode": "browser"}`}
    &response_type=code`;
  return (
    <div className='browser-login-root'>
      <div className='browser-login-card'>
        <img src={darkLogo} alt='QEP Logo' className='browser-login-logo' />
        <div className='browser-login-title'>QEP Login</div>
        {!isOpen && (
          <div className='browser-login-error-message'>
            Unable to connect to the server. Please check your network connection.
          </div>
        )}
        <button
          type='button'
          disabled={loading || !isOpen}
          onClick={() => {
            setLoading(true);
            globalThis.location.href = authUrl;
          }}
          className='browser-login-button'
        >
          {loading ? 'Redirecting...' : 'Sign in with SSO'}
        </button>
      </div>
    </div>
  );
};
